import { Close } from "@mui/icons-material";
import Dialog from "@mui/material/Dialog";
import { Box, DialogContent, DialogTitle, IconButton } from "@mui/material/index";
import CustomerBaseSearch from "../CustomerBaseSearch";
import CustomerBaseTable from "../CustomerBaseTable";
import { useSetRecoilState } from "recoil";
import { customerSearchFiltersState } from "../../state/customerbaseState";
import { useEffect } from "react";
import { CustomerBaseDto } from "../../types";

interface CBSearchCustomerWithFiltersDialogProps {
    open: boolean,
    title: string,
    onClose: () => void,
    onCustomerSelected: (selectedCustomer: CustomerBaseDto) => void

}

const CBSearchCustomerWithFiltersDialog = ({
    open,
    title,
    onClose,
    onCustomerSelected

}: CBSearchCustomerWithFiltersDialogProps) => {

    //const { t } = useTranslation("customerbase");
    
    const setCustomerSearchFilters = useSetRecoilState(customerSearchFiltersState);

    useEffect(() => {
        
        if(!open) setCustomerSearchFilters(null);

    }, [open]);

    return (
        <Dialog
            open={open}
            //onClose={onClose}
            fullWidth
            maxWidth="xl"
        >
            <IconButton
                sx={{
                    position: "absolute",
                    top: 12,
                    right: 12
                }}
                onClick={onClose}
            >
              <Close fontSize="inherit"/>  
            </IconButton>
            <DialogTitle>
                {title}
            </DialogTitle>
            <DialogContent>
                <Box p={2}>
                    <CustomerBaseSearch activePartnerType="organization"/>
                    <CustomerBaseTable activePartnerType="organization" onCustomerSelected={onCustomerSelected}/>
                </Box>
            </DialogContent>
        </Dialog>
    )

}

export default CBSearchCustomerWithFiltersDialog;